/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentsGetAgent } from "../../funcs/agentsGetAgent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAgentRequest$inboundSchema,
};

export const tool$agentsGetAgent: ToolDefinition<typeof args> = {
  name: "agents-get-agent",
  description: `Retrieve an agent`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentsGetAgent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
